import { getAiUsageTable, getSupabase, isSupabaseConfigured } from './supabaseClient';

const MAX_FIELD_CHARS = 25000;

function truncate(text, limit = MAX_FIELD_CHARS) {
  const value = text || '';
  if (value.length <= limit) return value;
  return `${value.slice(0, limit)}\n… [truncated ${value.length - limit} chars]`;
}

export async function logAiUsage({
  feature,
  userId = null,
  model = null,
  system = '',
  user = '',
  output = '',
  status = 'ok',
  error = null,
  latencyMs = null,
  metadata = {},
  app = 'quote-form',
}) {
  if (!isSupabaseConfigured()) {
    console.warn(
      'Supabase is not configured — AI usage not logged. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to .env',
    );
    return;
  }

  const supabase = getSupabase();
  const table = getAiUsageTable();

  try {
    const { error: insertError } = await supabase.from(table).insert({
      app,
      feature: feature || 'unknown',
      user_id: userId,
      model,
      status,
      error,
      latency_ms: latencyMs,
      input_chars: (system?.length || 0) + (user?.length || 0),
      output_chars: output?.length || 0,
      system_prompt_preview: truncate(system),
      user_input_preview: truncate(user),
      output_preview: truncate(output),
      metadata: metadata || {},
    });

    if (insertError) {
      console.error(
        'Supabase AI usage insert failed:',
        insertError.message,
        insertError.code,
        insertError.details,
        insertError.hint,
      );
      throw insertError;
    }
  } catch (err) {
    console.error('Failed to log AI usage to Supabase:', err?.message || err);
  }
}
